<template>
  <h2 class="mb-2.5 mt-8 border-t border-gray-900 text-text-md font-bold leading-5">
    <span class="relative -top-px inline-block border border-black bg-gray-800 px-2 py-1 text-white"><slot /></span>
  </h2>
</template>
